const About = () => {
  return <h1 className="text-2xl">Sobre o Meu App</h1>;
};

export default About;
